/**
 * Change search bar visibility with bootstrap d-flex class d-none
 */
const navbarSearchBtn = document.getElementById("navbarSearchBtn");
let navbarSearchForm;

window.displaySearchClick = function () {
  navbarSearchForm = document.getElementById("navbarSearchForm");
  if (navbarSearchForm.classList.contains("d-none")) {
    navbarSearchForm.classList.remove("d-none");
  } else {
    navbarSearchForm.classList.add("d-none");
  }
};

navbarSearchBtn.addEventListener("click", function () {
  displaySearchClick();
});
